<section class="latest-news" [class.dark-theme]="isDarkMode" [class.light-theme]="!isDarkMode">
        <div class="container">
            <div class="header">
                <h2 class="title">CASOS DE USO </h2>
                <div class="divider"></div>
            </div>

            <div class="articles-container">
                <!-- Primera fila: artículos 1 y 2 -->
                <div class="articles-row articles-row-top">
                    <!-- Article 1 -->
                    <article class="article-card">
                        <div class="article-content">
                            <h3 class="article-title">¡INTEGRA PUNTO DE FUGA EN TUS SITIOS WEB O APPS!</h3>
                        </div>
                        <div class="article-image">
                            <img src="assets/imagenes/caso4.png" alt="Electronic devices">
                        </div>
                        <div class="article-content">
                            <ul class="article-description">
                                <li>
                                    <span class="list-icon"><img src="assets/iconos/icon11.png" alt="icon"></span>
                                    Conecta nuestra API al backend de tu app y transforma el flujo comercial. 
                                </li>
                                <li>
                                    <span class="list-icon"><img src="assets/iconos/icon12.png" alt="icon"></span>
                                    Edición, optimización y sincronización en un solo paso.
                                </li>
                                <li>
                                    <span class="list-icon"><img src="assets/iconos/icon13.png" alt="icon"></span>
                                    Menos clics, más resultados.
                            </ul>
                        </div>
                    </article>
                    
                    <!-- Article 2 -->
                    <article class="article-card">
                        <div class="article-content">
                            <h3 class="article-title"> ¡EDICIÓN INSTANTÁNEA!</h3>
                        </div>
                        <div class="article-image">
                            <img src="assets/imagenes/caso1.png" alt="Workspace">
                        </div>
                        <div class="article-content">
                            <ul class="article-description">
                                <li>
                                    <span class="list-icon"><img src="assets/iconos/icon1.png" alt="icon"></span>
                                    Toma una foto, elige un estilo y ajusta lo necesario sin entrenar modelos. 
                                </li>
                                <li>
                                    <span class="list-icon"><img src="assets/iconos/icon2.png" alt="icon"></span>
                                Nuestra IA transforma tu imagen en contenido profesional en solo SEGUNDOS.
                                </li>
                                <li>
                                    <span class="list-icon"><img src="assets/iconos/icon3.png" alt="icon"></span>
                                    NO necesitas saber de edición, todo sucede en tu app, sin esfuerzo.
                                </li>
                            </ul>
                        </div>
                    </article>
                </div>

                <!-- Segunda fila: artículos 3 y 4 -->
                <div class="articles-row articles-row-bottom">
                     <!-- Article 4 -->
                    <article class="article-card">
                        <div class="article-content">
                            <h3 class="article-title">¡CREA TUS PROPIOS BANNERS! </h3>
                        </div>
                        <div class="article-image">
                            <img src="assets/imagenes/caso2.png" alt="Creative workspace">
                        </div>
                        <div class="article-content">
                            <ul class="article-description">
                                <li>
                                    <span class="list-icon"><img src="assets/iconos/icon4.png" alt="icon"></span>
                                    Elige una plantilla y escribe tu mensaje. 
                                </li>
                                <li>
                                    <span class="list-icon"><img src="assets/iconos/icon5.png" alt="icon"></span>
                                    Agrega formas e imagenes y aplica tu marca.
                                </li>
                                <li>
                                    <span class="list-icon"><img src="assets/iconos/icon6.png" alt="icon"></span>
                                    Punto de Fuga convierte tu idea en un banner profesional en segundos. Sin diseñadores, sin complicaciones.
                                </li>
                            </ul>
                        </div>
                    </article>

                    <!-- Article 3 -->
                    <article class="article-card">
                        <div class="article-content">
                            <h3 class="article-title"> ¡AJUSTA TU FOTO DE PERFIL! </h3>
                        </div>
                        <div class="article-image">
                            <img src="assets/imagenes/caso3.png" alt="Open book">
                        </div>
                        <div class="article-content">
                            <ul class="article-description">
                                <li>
                                    <span class="list-icon"><img src="assets/iconos/icon9.png" alt="icon"></span>
                                    Sube tu foto y en segundos tendrás un perfil profesional
                                </li>
                                <li>
                                    <span class="list-icon"><img src="assets/iconos/icon10.png" alt="icon"></span>
                                    La IA corrige el encuadre y fondo para que tu imagen hable por ti.
                                </li>
                            </ul>
                        </div>
                    </article>
                </div>
            </div>
        </div>
    </section>
    <footer>
      <div class="footer-container">
        <p data-i18n="footerCopyright">&copy; 2025 Punto de Fuga. Todos los derechos reservados.</p>
        <div class="footer-links">
          <a routerLink="/privacy" data-i18n="footerPrivacy">Política de Privacidad</a>
          <a routerLink="/support" data-i18n="footerContact">Soporte</a>
        </div>
      </div>
    </footer>